import React from 'react';

export type OnetrackParasm = Record<string, any>;
export const OnetrackContext = React.createContext<OnetrackOptions>({});

export interface OnetrackOptions {
  params?: OnetrackParasm | (() => OnetrackParasm);
}
export const OnetrackProvider: React.FC<OnetrackOptions> = ({
  children,
  ...options
}) => {
  const context = React.useContext(OnetrackContext);
  const { params, ...rest } = options;

  return (
    <OnetrackContext.Provider
      value={{
        ...context,
        ...rest,
        params: () => ({
          ...(typeof context.params === 'function'
            ? context.params()
            : context.params),
          ...(typeof params === 'function' ? params() : params)
        }),
      }}
    >
      {children}
    </OnetrackContext.Provider>
  );
};

export default {};
